<template>
    <div class="calendar-navigation">
        <!-- Part 1: Date Navigation -->
        <div class="date-navigation">
            <div class="month-selector">
                <div @click="changeMonth(-1)"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="19"
                        viewBox="0 0 18 19" fill="none">
                        <path
                            d="M12.4649 16.2576C12.0974 16.6251 11.5049 16.6251 11.1374 16.2576L4.90492 10.0251C4.61242 9.73258 4.61242 9.26008 4.90492 8.96758L11.1374 2.73508C11.5049 2.36758 12.0974 2.36758 12.4649 2.73508C12.8324 3.10258 12.8324 3.69508 12.4649 4.06258L7.03492 9.50008L12.4724 14.9376C12.8324 15.2976 12.8324 15.8976 12.4649 16.2576Z"
                            fill="white" />
                    </svg></div>
                <span style="width: 130px;text-align: center;">{{ currentMonthYear }}</span>
                <div @click="changeMonth(1)"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="19"
                        viewBox="0 0 18 19" fill="none">
                        <path
                            d="M5.53508 16.2576C5.90258 16.6251 6.49508 16.6251 6.86258 16.2576L13.0951 10.0251C13.3876 9.73258 13.3876 9.26008 13.0951 8.96758L6.86258 2.73508C6.49508 2.36758 5.90258 2.36758 5.53508 2.73508C5.16758 3.10258 5.16758 3.69508 5.53508 4.06258L10.9651 9.50008L5.52758 14.9376C5.16758 15.2976 5.16758 15.8976 5.53508 16.2576Z"
                            fill="white" />
                    </svg></div>
            </div>
            <div class="calendarTitle">Event Calendar</div>
            <div class="week-selector">
                <div @click="changeWeek(-1)"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="19"
                        viewBox="0 0 18 19" fill="none">
                        <path
                            d="M12.4649 16.2576C12.0974 16.6251 11.5049 16.6251 11.1374 16.2576L4.90492 10.0251C4.61242 9.73258 4.61242 9.26008 4.90492 8.96758L11.1374 2.73508C11.5049 2.36758 12.0974 2.36758 12.4649 2.73508C12.8324 3.10258 12.8324 3.69508 12.4649 4.06258L7.03492 9.50008L12.4724 14.9376C12.8324 15.2976 12.8324 15.8976 12.4649 16.2576Z"
                            fill="white" />
                    </svg></div>
                <span style="width: 130px;text-align: center;margin-top: -7px;">{{ currentWeek }}</span>
                <div @click="changeWeek(1)"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="19"
                        viewBox="0 0 18 19" fill="none">
                        <path
                            d="M5.53508 16.2576C5.90258 16.6251 6.49508 16.6251 6.86258 16.2576L13.0951 10.0251C13.3876 9.73258 13.3876 9.26008 13.0951 8.96758L6.86258 2.73508C6.49508 2.36758 5.90258 2.36758 5.53508 2.73508C5.16758 3.10258 5.16758 3.69508 5.53508 4.06258L10.9651 9.50008L5.52758 14.9376C5.16758 15.2976 5.16758 15.8976 5.53508 16.2576Z"
                            fill="white" />
                    </svg></div>
            </div>
        </div>

        <!-- Part 2: Event Types (Visual Only) -->
        <div class="event-types">
            <div class="event-type internal-event">Division Events</div>
            <div class="event-type board-meeting">Partner Events</div>
            <div class="event-type all-member-meeting">Board Events</div>
        </div>

        <!-- Part 3: Days of the Week with Events  //justify-content: space-between;//-->
        <div class="week-days">
            <div class="loading-donut" v-if="loadingEvents"></div>
            <div v-for="(day, dayIndex) in weekDays" :key="dayIndex" class="dayContainer">
                <div class="day"
                    :style="{ 'justify-content': eventsForDate(day.fullDate).length > maxEventsToShow ? 'space-between' : '' }">

                    <div class="dateContainer">
                        <div class="date-number">{{ day.date }}</div>
                        <div class="date-name">{{ day.name }}</div>
                    </div>
                    <!-- Events for the day -->
                    <div class="eventContainer">
                        <div class="events" v-for="(event, eventIndex) in eventsForDate(day.fullDate)" :key="eventIndex"
                            v-if="eventIndex < maxEventsToShow" :style="{ borderColor: getTagColor(event.tag) }"
                            @click="showTooltip(event)">
                            <div class="event-details">
                                <div class="event-time"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17"
                                        viewBox="0 0 20 21" fill="none" class="svgClockIcon">
                                        <path
                                            d="M10 18.5C12.1217 18.5 14.1566 17.6571 15.6569 16.1569C17.1571 14.6566 18 12.6217 18 10.5C18 8.37827 17.1571 6.34344 15.6569 4.84315C14.1566 3.34285 12.1217 2.5 10 2.5C7.87827 2.5 5.84344 3.34285 4.34315 4.84315C2.84285 6.34344 2 8.37827 2 10.5C2 12.6217 2.84285 14.6566 4.34315 16.1569C5.84344 17.6571 7.87827 18.5 10 18.5ZM10 0.5C11.3132 0.5 12.6136 0.758658 13.8268 1.2612C15.0401 1.76375 16.1425 2.50035 17.0711 3.42893C17.9997 4.35752 18.7362 5.45991 19.2388 6.67317C19.7413 7.88642 20 9.18678 20 10.5C20 13.1522 18.9464 15.6957 17.0711 17.5711C15.1957 19.4464 12.6522 20.5 10 20.5C4.47 20.5 0 16 0 10.5C0 7.84784 1.05357 5.3043 2.92893 3.42893C4.8043 1.55357 7.34784 0.5 10 0.5ZM10.5 5.5V10.75L15 13.42L14.25 14.65L9 11.5V5.5H10.5Z"
                                            fill="#333333" />
                                    </svg>{{ event.time }}</div>
                                <div class="event-name-calendar" v-html="event.name"></div>
                            </div>

                            <!-- tooltip -->
                            <div v-if="activeTooltip === event" class="tooltip">
                                <div class="close-button" @click.stop="closeTooltip">X</div>
                                <div>
                                    <div class="event-details">
                                        <div class="event-name"
                                            style="padding-top: 5px; padding-bottom: 5px; padding-right: 20px;">{{
                                                event.name }}</div>

                                        <div class="event-time"><svg xmlns="http://www.w3.org/2000/svg" width="17"
                                                height="17" viewBox="0 0 20 21" fill="none" class="svgClockIcon">
                                                <path
                                                    d="M10 18.5C12.1217 18.5 14.1566 17.6571 15.6569 16.1569C17.1571 14.6566 18 12.6217 18 10.5C18 8.37827 17.1571 6.34344 15.6569 4.84315C14.1566 3.34285 12.1217 2.5 10 2.5C7.87827 2.5 5.84344 3.34285 4.34315 4.84315C2.84285 6.34344 2 8.37827 2 10.5C2 12.6217 2.84285 14.6566 4.34315 16.1569C5.84344 17.6571 7.87827 18.5 10 18.5ZM10 0.5C11.3132 0.5 12.6136 0.758658 13.8268 1.2612C15.0401 1.76375 16.1425 2.50035 17.0711 3.42893C17.9997 4.35752 18.7362 5.45991 19.2388 6.67317C19.7413 7.88642 20 9.18678 20 10.5C20 13.1522 18.9464 15.6957 17.0711 17.5711C15.1957 19.4464 12.6522 20.5 10 20.5C4.47 20.5 0 16 0 10.5C0 7.84784 1.05357 5.3043 2.92893 3.42893C4.8043 1.55357 7.34784 0.5 10 0.5ZM10.5 5.5V10.75L15 13.42L14.25 14.65L9 11.5V5.5H10.5Z"
                                                    fill="#333333" />
                                            </svg>{{ event.time }}</div>
                                    </div>
                                    <div v-html="parseDescription(event.description)"></div>
                                </div>
                            </div>

                        </div>
                        <div class="more-events" v-if="eventsForDate(day.fullDate).length > maxEventsToShow"
                            @click="toggleDropdown(dayIndex)">
                            +{{ eventsForDate(day.fullDate).length - maxEventsToShow }} events
                        </div>

                        <!-- Dropdown for extra events -->
                        <div class="dropdown" v-if="activeDayForDropdown === dayIndex">
                            <div class="dropdown-content">
                                <!-- Iterate through the extra events and display them -->
                                <div v-for="(event, eventIndex) in eventsForDate(day.fullDate).slice(maxEventsToShow)"
                                    :key="eventIndex">
                                    <div class="eventdropdownItem">
                                        <div class="event-time"> <svg xmlns="http://www.w3.org/2000/svg" width="17"
                                                height="17" viewBox="0 0 20 21" fill="none" class="svgClockIcon">
                                                <path
                                                    d="M10 18.5C12.1217 18.5 14.1566 17.6571 15.6569 16.1569C17.1571 14.6566 18 12.6217 18 10.5C18 8.37827 17.1571 6.34344 15.6569 4.84315C14.1566 3.34285 12.1217 2.5 10 2.5C7.87827 2.5 5.84344 3.34285 4.34315 4.84315C2.84285 6.34344 2 8.37827 2 10.5C2 12.6217 2.84285 14.6566 4.34315 16.1569C5.84344 17.6571 7.87827 18.5 10 18.5ZM10 0.5C11.3132 0.5 12.6136 0.758658 13.8268 1.2612C15.0401 1.76375 16.1425 2.50035 17.0711 3.42893C17.9997 4.35752 18.7362 5.45991 19.2388 6.67317C19.7413 7.88642 20 9.18678 20 10.5C20 13.1522 18.9464 15.6957 17.0711 17.5711C15.1957 19.4464 12.6522 20.5 10 20.5C4.47 20.5 0 16 0 10.5C0 7.84784 1.05357 5.3043 2.92893 3.42893C4.8043 1.55357 7.34784 0.5 10 0.5ZM10.5 5.5V10.75L15 13.42L14.25 14.65L9 11.5V5.5H10.5Z"
                                                    fill="#333333" />
                                            </svg>{{ event.time }}</div>
                                        <div class="event-name" v-html="event.name"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <!-- Line and Month Name if it's the last day of the month -->
                <div v-if="isLastDayOfMonth(day.fullDate)">
                    <div class="month-name">{{ getMonthName(day.fullDate) }}</div>
                    <div class="month-separator"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as ICAL from 'ical.js';

export default {
    data() {
        return {
            activeDayForDropdown: null,
            activeTooltip: null,
            currentDate: new Date(),
            maxEventsToShow: 3,
            loadingEvents: true,
            events: [
                /* { date: '27 november 2023', name: 'Healthy Minds, Healthy Distractions', tag: 'Board Meeting', time: '7:30 pm' },
                { date: '27 november 2023', name: 'Healthy Minds, Healthy Distractions', tag: 'Board Meeting', time: '2:30 pm' },
                { date: '27 november 2023', name: 'Healthy Minds, Healthy Distractions', tag: 'Board Meeting', time: '3:30 pm' },
                { date: '27 november 2023', name: 'Healthy Minds, Healthy Distractions', tag: 'Board Meeting', time: '4:30 pm' },
                { date: '27 november 2023', name: 'Healthy Minds, Healthy Distractions', tag: 'Board Meeting', time: '5:30 pm' },

                { date: '28 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'Internal Event', time: '4:30 pm' },
                { date: '28 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'All-member meeting', time: '4:30 pm' },
                { date: '28 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'Board meeting', time: '4:30 pm' },
                { date: '28 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'Internal Event', time: '4:30 pm' },
                { date: '28 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'Internal Event', time: '4:30 pm' },

                { date: '29 november 2023', name: 'Therapeutics Initiative Annual Course', tag: 'Internal Event', time: '4:30 pm' }, */

            ],
            // ... other data properties
            // application_ID : 720aec5e-0041-4799-8651-f205fd73f80b
            // client_secret : W1e8Q~T_-cJ4iqlZ.9tGnsEsckE4MU1JeGYV0aF2

        }
    },
    computed: {
        currentMonthYear() {
            const options = { month: 'long', year: 'numeric' };
            return this.currentDate.toLocaleDateString('en-US', options);
        },
        currentWeek() {
            const startOfWeek = this.getStartOfWeek(this.currentDate);
            const endOfWeek = new Date(startOfWeek);
            endOfWeek.setDate(startOfWeek.getDate() + 6);

            return `Mon ${startOfWeek.getDate()} - Sun ${endOfWeek.getDate()}`;
        },
        weekDays() {
            let days = [];
            let startOfWeek = this.getStartOfWeek(this.currentDate);

            for (let i = 0; i < 7; i++) {
                let day = new Date(startOfWeek);
                day.setDate(startOfWeek.getDate() + i);

                days.push({
                    date: day.getDate().toString().padStart(2, '0'),
                    name: day.toLocaleDateString('en-US', { weekday: 'long' }),
                    fullDate: day.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })
                        .replace(/ /g, ' '), // Format: '01 November 2023'
                });
            }

            return days;
        },
    },
    methods: {
        getStartOfWeek(date) {
            const day = date.getDay();
            const diff = date.getDate() - day + (day === 0 ? -6 : 1);
            return new Date(date.setDate(diff));
        },
        changeMonth(step) {
            const newDate = new Date(this.currentDate.setMonth(this.currentDate.getMonth() + step));
            this.currentDate = newDate;
            //    console.log(newDate)
            let test = (!this.isLastDayOfMonthVisible());
            //   console.log(test)
            if (test) { this.changeWeek(1) };

            this.checkLastDayOfMonthVisible();
        },

        checkLastDayOfMonthVisible() {

            this.$nextTick(() => {
                if (!this.isLastDayOfMonthVisible()) {
                    this.changeWeek(-1);
                    this.checkLastDayOfMonthVisible();
                }
            });
        },
        changeWeek(step) {
            const newDate = new Date(this.currentDate.setDate(this.currentDate.getDate() + (step * 7)));
            this.currentDate = newDate;
        },
        eventsForDate(fullDate) {
            let dayEvents = this.events.filter(event => event.date.toLowerCase() === fullDate.toLowerCase());

            dayEvents.sort((a, b) => this.convertTo24Hour(a.time) - this.convertTo24Hour(b.time));

            return dayEvents;
        },

        convertTo24Hour(timeStr) {
            const [time, modifier] = timeStr.split(' ');
            let [hours, minutes] = time.split(':');
            hours = parseInt(hours, 10);
            minutes = parseInt(minutes, 10);

            if (hours === 12) {
                hours = modifier === 'am' ? 0 : 12;
            } else {
                hours = modifier === 'pm' ? hours + 12 : hours;
            }

            return new Date(1970, 0, 1, hours, minutes);
        },
        getTagColor(tag) {
            const tagColors = {
                265: '#006D8A',
                267: '#EEB844',
                266: '#BBBF9A',
            };
            return tagColors[tag] || '#006D8A';
        },
        isLastDayOfMonth(fullDate) {
            const date = new Date(fullDate);
            const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            return date.getDate() === lastDay.getDate();
        },
        getMonthName(fullDate) {
            const date = new Date(fullDate);
            const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);
            return nextMonth.toLocaleDateString('default', { month: 'long' });
        },
        isLastDayOfMonthVisible() {
            return this.weekDays.some(day => this.isLastDayOfMonth(day.fullDate));
        },

        updateMaxEventsToShow() {
            if (window.innerWidth < 750) {
                this.maxEventsToShow = 2;
            } else {
                this.maxEventsToShow = 3;
            }

            if (window.innerWidth < 550) { this.maxEventsToShow = 3; }
        },
        toggleDropdown(dayIndex) {
            this.activeTooltip = null;
            if (this.activeDayForDropdown === dayIndex) {
                this.activeDayForDropdown = null; // Hide if the same day is clicked again
            } else {
                this.activeDayForDropdown = dayIndex; // Show for the clicked day
            }
        },

         showTooltip(event) {
            if (event.link) {
              window.location.href = event.link;
            //   console.log(event.link)
            } else {
                console.error("Event does not have a valid link:", event);
            }
        },

        closeTooltip() {
            this.activeTooltip = null;
        },

        parseDescription(desc) {
            // console.log(desc);

            // Remove everything after the '<https>' tag, including the tag itself
            let textBeforeHttps = desc.split('<https')[0];
            // console.log(textBeforeHttps);

            // Convert emails within 'mailto:' tags to clickable links and remove the 'mailto:' tag itself
            let textWithEmails = textBeforeHttps.replace(
                /<mailto:([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)>/gi,
                (match, email) => `<a href="mailto:${email}">${email}</a>`
            );
            // console.log(textWithEmails);

            // Convert plaintext URLs to clickable links, prepending 'http://' if necessary.
            // This pattern ensures it does not match email addresses again.
            let textWithLinks = textWithEmails.replace(
                /(?:http(s)?:\/\/|www\.)\S+/gi,
                (match) => `<a href="${match.startsWith('http') ? '' : 'http://'}${match}" target="_blank">${match}</a>`
            );
            // console.log(textWithLinks);

            // Replace consecutive line breaks with a single line break
            let singleBreaksText = textWithLinks.replace(/\n\s*\n/g, '\n');

            // Remove any duplicate email addresses that appear before their corresponding <a> tag
            let cleanedText = singleBreaksText.replace(
                /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)(?=<a href="mailto:\1">)/gi,
                ''
            );
            // console.log(cleanedText);

            // Convert all line breaks into '<br>' tags for HTML display
            return cleanedText.replace(/\n/g, '<br>');
        },




        loadEvents() {
            const wpapi = '/wp-json/wp/v2/event';
            let allEvents = [];
            this.loadingEvents = true;

            const fetchPage = (page = 1) => {
                return fetch(`${wpapi}?per_page=100&page=${page}`)
                    .then(response => {
                        if (!response.ok) throw new Error(`Error fetching events (page ${page}): ${response.status}`);
                        const totalPages = parseInt(response.headers.get('X-WP-TotalPages'), 10);
                        return response.json().then(data => ({ data, totalPages }));
                    })
                    .then(({ data, totalPages }) => {
                        allEvents = allEvents.concat(data);
                        if (page < totalPages) {
                            return fetchPage(page + 1); // Return the Promise for chaining
                        } else {
                            this.processEvents(allEvents);
                            this.loadingEvents = false;
                        }
                    })
                    .catch(error => console.error('Error fetching events: ', error));
            };

            fetchPage(); // Start the fetching process
        },

        processEvents(events) {
            const dataArray = events.map(event => {
                let obj = {};
                let calendarTag = 265; // Default Division Events ID
                if (event.calendar_tags.length > 0) {
                    calendarTag = event.calendar_tags[0];
                }
                if (event.calendar_tags.length == 0) {
                    calendarTag = 265;
                }
                obj.summary = event.title.rendered;
                obj.startDate = event.acf['event-start_date'];
                obj.startTime = event.acf['event-start_time']; // Use ACF start time
                obj.description = event.acf['post-excerpt'];
                obj.categories = calendarTag;
                obj.link = event.link;
                obj.id = event.id;
                return obj;
            });

            this.events = this.convertArrayOfObjects(dataArray);
        },

        convertArrayOfObjects(inputArray) {
            function parseDateString(dateString) {
                let startDate;

                if (dateString.includes("/")) {
                    const [month, day, year] = dateString.split("/").map(Number);
                    const fullYear = year < 100 ? 2000 + year : year; // Handle 2-digit year
                    startDate = new Date(fullYear, month - 1, day);
                } else if (dateString.length === 8) {
                    const year = parseInt(dateString.substring(0, 4), 10);
                    const month = parseInt(dateString.substring(4, 6), 10) - 1;
                    const day = parseInt(dateString.substring(6, 8), 10);
                    startDate = new Date(year, month, day);
                } else {
                    console.log(inputArray);
                    throw new Error("Invalid date format. Use either 'YYYYMMDD' or 'MM/DD/YY'.");
                }

                return startDate;
            }

            return inputArray
                .filter(obj => {
                    if (obj.startDate === "03/26/25" && obj.id !== 19263 && obj.id !== 19264) {
                        return false;
                    }
                    return true;
                })
                .map(obj => {
                    const startDate = parseDateString(obj.startDate);

                    const formattedDay = startDate.getDate().toString().padStart(2, '0');
                    const formattedMonth = startDate.toLocaleString('en-US', { month: 'long' });
                    const formattedYear = startDate.getFullYear();
                    const formattedDate = `${formattedDay} ${formattedMonth} ${formattedYear}`;

                    let formattedTime = '12:00 am';
                    if (obj.startTime) {
                        const [hours, minutes] = obj.startTime.split(':');
                        const hr = parseInt(hours, 10);
                        const ampm = hr >= 12 ? '' : '';
                        formattedTime = `${(hr % 12 || 12)}:${minutes} ${ampm}`;
                    }

                    return {
                        name: obj.summary,
                        description: obj.description,
                        tag: obj.categories,
                        link: obj.link,
                        time: formattedTime.toLowerCase(),
                        date: formattedDate,
                    };
                });
        },


        
        loadEvents2() {
            const corsProxyUrl = 'https://corsproxy.io/?';
            const outlookIcsUrl = 'https://outlook.office365.com/owa/calendar/b8f430694e0b4e52b5a31ca13debfa27@victoriadivision.ca/0bc97c17f8404f068d40ff329d6e028817980208403851609734/calendar.ics';

            fetch(`${corsProxyUrl}${outlookIcsUrl}`)
                .then(response => response.text())
                .then(data => {
                    const jcalData = ICAL.parse(data);
                    const comp = new ICAL.Component(jcalData);
                    const events = comp.getAllSubcomponents('vevent');

                    let eventsArray = events.map(event => {
                        const startDate = event.getFirstPropertyValue('dtstart').toJSDate();

                        const day = startDate.getDate().toString().padStart(2, '0');
                        const month = startDate.toLocaleString('en-US', { month: 'long' });
                        const year = startDate.getFullYear();

                        const hours = startDate.getHours();
                        const minutes = startDate.getMinutes().toString().padStart(2, '0');
                        const ampm = hours >= 12 ? 'pm' : 'am';
                        const formattedTime = `${(hours % 12) || 12}:${minutes} ${ampm}`;

                        return {
                            name: event.getFirstPropertyValue('summary'),
                            description: event.getFirstPropertyValue('description'),
                            tag: 'External event',
                            time: formattedTime.toLowerCase(),
                            date: `${day} ${month} ${year}`
                        };
                    });

                    this.events = [...this.events, ...eventsArray];
                    this.loadEvents3(); // Proceed to load events from the third source
                })
                .catch(error => console.error('Error fetching the ICS file:', error));
        }
        ,
        loadEvents3() {
            const corsProxyUrl = 'https://corsproxy.io/?';
            const googleIcsUrl = 'https://calendar.google.com/calendar/ical/2por7b281u6448ptl46qb7sijsrfu75u%40import.calendar.google.com/public/basic.ics';

            fetch(`${corsProxyUrl}${googleIcsUrl}`)
                .then(response => response.text())
                .then(data => {
                    const jcalData = ICAL.parse(data);
                    const comp = new ICAL.Component(jcalData);
                    const events = comp.getAllSubcomponents('vevent');

                    let eventsArray = events.map(event => {
                        const startDate = event.getFirstPropertyValue('dtstart').toJSDate();

                        const day = startDate.getDate().toString().padStart(2, '0');
                        const month = startDate.toLocaleString('en-US', { month: 'long' });
                        const year = startDate.getFullYear();

                        const hours = startDate.getHours();
                        const minutes = startDate.getMinutes().toString().padStart(2, '0');
                        const ampm = hours >= 12 ? 'pm' : 'am';
                        const formattedTime = `${(hours % 12) || 12}:${minutes} ${ampm}`;

                        return {
                            name: event.getFirstPropertyValue('summary'),
                            description: event.getFirstPropertyValue('description'),
                            tag: 'Internal event',
                            time: formattedTime.toLowerCase(),
                            date: `${day} ${month} ${year}`
                        };
                    });

                    this.events = [...this.events, ...eventsArray];
                })
                .catch(error => console.error('Error fetching the ICS file:', error));
        }
        ,
    },
    created() {
        window.addEventListener('resize', this.updateMaxEventsToShow);
        this.updateMaxEventsToShow();
    },
    destroyed() {
        window.removeEventListener('resize', this.updateMaxEventsToShow);
    },
    mounted() {
        this.loadEvents()

        //  this.loadEvents3()
        /*     this.events = [
                   {
                       "date": "28 November 2023",
                       "name": "Sample Event",
                       "tag": "Internal event",
                       "time": "8:00 am"
                   },
                   {
                       "date": "28 November 2023",
                       "name": "Sample Event",
                       "tag": "Board meeting",
                       "time": "9:00 am"
                   },
                   {
                       "date": "28 November 2023",
                       "name": "Sample Event",
                       "tag": "External event",
                       "time": "12:00 pm"
                   },
                   {
                       "date": "28 November 2023",
                       "name": "Sample Event",
                       "tag": "All-member meeting",
                       "time": "2:30 pm"
                   },
                   {
                       "date": "28 November 2023",
                       "name": "Sample Event",
                       "tag": "Internal Event",
                       "time": "6:30 pm"
                   },
                   {
                       "date": "29 November 2023",
                       "name": "Sample Event",
                       "tag": "Internal Event",
                       "time": "8:00 am"
                   },
                   {
                       "date": "29 November 2023",
                       "name": "Sample Event",
                       "tag": "External event",
                       "time": "10:00 am"
                   },
                   {
                       "date": "29 November 2023",
                       "name": "Sample Event",
                       "tag": "Board meeting",
                       "time": "5:00 pm"
                   },
                   {
                       "date": "02 December 2023",
                       "name": "Sample Event",
                       "tag": "External event",
                       "time": "3:30 pm"
                   }
               ]
                   */

    }
}
</script>



<style>
/*  
    

*/

.calendar-navigation {
    font-family: 'Arial', sans-serif;

}

.calendarTitle {
    font-weight: bold;
}

.month-selector {
    font-weight: bold;
}

.month-selector>div {
    cursor: pointer;
}

.week-selector {
    font-weight: bold;
}

.week-selector>div {
    cursor: pointer;
}

.date-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #428DA1;
    color: white;
    padding: 10px;
}



.month-selector,
.week-selector {
    display: flex;
    align-items: center;
}

/* .calendar-navigation button {
    background-color: transparent;
    border: none;
    color: white;
    cursor: pointer;
}

.calendar-navigation span {
    margin: 0 10px;
}
 */
.eventContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.events {
    padding: 0px 15px;
    border-left: 7px solid #016d89;
    padding-left: 5px;
    margin-left: 0px;
    height: 75px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 293.3px;
    min-width: 293.3px;
    cursor: pointer;
}

.event-time {
    font-size: 20px;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.event-name {
    font-size: 15px;
    color: #006d8a;
    font-family: "Roboto Slab", Sans-serif;
    font-weight: 500;
}


.event-name-calendar {
    font-size: 14px;
    color: #006d8a;
    font-family: "Roboto Slab", Sans-serif;
    font-weight: 500;
}

.svgClockIcon {
    margin-right: 5px;
}

.event-types {
    display: flex;
    justify-content: space-between;
}

.event-type {
    flex-grow: 1;
    text-align: center;
    padding: 10px;
    color: white;
}

.internal-event {
    background-color: #006D8A;
}

.external-event {
    background-color: #E48F5B;
}

.all-member-meeting {
    background-color: #EEB844;
}

.board-meeting {
    background-color: #BBBF9A;
}

.week-days {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 0px;
    position: relative;
}

.loading-donut {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90px;
    height: 90px;
    border: 20px solid rgba(0, 0, 0, 0.1);
    border-top: 20px solid #006D8A;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    z-index: 200;
}

@keyframes spin {
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}


.dateContainer {
    display: flex;
    width: 130px;
    min-width: 130px;
    align-items: center;
    flex-direction: column;
    text-align: center;
    transform: translateX(-20px);
}

.dayContainer {
    border: 1px solid rgb(193, 193, 193);
    border-top: 0px;
    margin: 0;
    min-width: 100px;
}

.day {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0px;
    padding-left: 15px;
    justify-content: flex-start;
    flex-direction: row;
}

.date-number {
    font-size: 32px;
    font-weight: bold;
}

.date-name {
    font-size: 12px;
    color: #555;
    margin-top: -3px;
}

.month-separator {
    height: 2px;
    background-color: #ccc;
    margin-top: 2px;
}

.month-name {
    font-size: 0.75rem;
    color: #666;
    text-align: center;
    margin-top: -10px;
}

.event-tag {
    width: 5px;
    height: 100%;
    border-left: 5px solid;
    /* Color will be set dynamically */
}

.more-events {
    height: 75px;
    display: flex;
    align-content: center;
    align-items: center;
    background-color: #CE7234;
    padding: 0px 20px;
    color: white;
    font-weight: bold;
    cursor: pointer;
}

.more-events:hover {
    text-decoration: underline;
}

.dropdown-content {
    position: absolute;
    width: 250px;
    margin-left: -21.8%;
    margin-top: 2%;
    border-radius: 5px;
    background-color: white;
    border: 1px solid rgb(213, 213, 213);
}

.eventdropdownItem {
    padding: 10px;
    border-bottom: 1px solid rgb(213, 213, 213);

}

@media (max-width: 1060px) {
    .events {
        width: 255px;
        min-width: 255px;
    }
}


.tooltip {
    position: absolute;
    width: auto;
    min-width: 200px;
    max-width: 700px;
    margin-left: 0;
    margin-top: 7%;
    border-radius: 5px;
    background-color: white;
    border: 1px solid rgb(213, 213, 213);
    padding: 10px;
    overflow: hidden;
    cursor: default;
}

.tooltip a {
    color: #E48F5B;

}

.close-button {
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
    color: grey;
    font-size: 15px;
    font-family: monospace;

}

@media (max-width: 720px) {

    .date-navigation {
        display: flex;
        flex-direction: column;

    }

    .month-selector {
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .calendarTitle {
        order: -1;
    }

    .eventContainer {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        width: 100%;
    }

    .day {
        justify-content: flex-start !important;
    }

    .dateContainer {
        display: flex;
        width: 80px;
        min-width: 80px;
        align-items: center;
        flex-direction: column;
        text-align: center;
        transform: translateX(-10px);
    }

    .more-events {
        height: 40px;
        text-align: center;
        justify-content: center;
    }

    .dropdown-content {
        position: absolute;
        width: 300px;
        margin-left: 0;
        margin-top: 0%;
        border-radius: 5px;
        background-color: white;
        border: 1px solid rgb(213, 213, 213);
    }

    .tooltip {
        position: absolute;
        width: 95%;
        left: 10px;
        z-index: 99;
        min-width: 100px;
        max-width: 600px;
        margin-left: 0;
        margin-top: 7%;
        border-radius: 5px;
        background-color: white;
        border: 1px solid rgb(213, 213, 213);
        padding: 10px;
        overflow: hidden;
    }

}
</style>


// WEBPACK FOOTER //
// src/calendar.vue